// this.$store.state.vehiculo
import { serverTimestamp } from "firebase/firestore";

// VEHICULOS
export const vehiculo = class {
  constructor() {
    return {
      id: "",
      idEmpresa: "",
      idUsuario: "",
      placa: "",
      clase: "",
      marca: "",
      cilindraje: 0,
      modelo: "",
      color: "",
      kilometraje: {
        registro: 0,
        mantenimiento: 0,
      },
      servicio: "",
      tipoCombustible: "",
      tipoVinculacion: "",
      dispositivoZonaCliente: "",
      fotos: [],
      rodamiento: {
        valor: "Si",
        archivo: {
          nombre: "",
          tipo: "",
          url: "",
        },
      },
      cartaCompromiso: {
        valor: "Si",
        archivo: {
          nombre: "",
          tipo: "",
          url: "",
        },
      },
      registro: {
        creacion: serverTimestamp(),
        actualizacion: serverTimestamp(),
        estado: "Creado",
      },
    };
  }
};
